import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "xradio" }
const _hoisted_3 = ["name", "checked"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "xcheck" }
const _hoisted_6 = ["name", "checked"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = { key: 3 }

import { PropType, computed } from "vue";
import { FilterDefinition, FilterOption } from "@/types/search-page";
import { useSearchPageStore } from "@/store/store/searchPageStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageFilterOption',
  props: {
  filterDefinition: {
    type: Object as PropType<FilterDefinition>,
    required: true,
  },
  filterOption: {
    type: Object as PropType<FilterOption>,
    required: true,
  },
  showAllFilterOptions: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const searchPageStore = useSearchPageStore();

const props = __props;

const filterOptions = computed(() => {
  if (props.filterDefinition.maxVisibleOptions && !props.showAllFilterOptions) {
    return searchPageStore
      .filteredSectionResults(props.filterDefinition)
      .slice(0, props.filterDefinition.maxVisibleOptions);
  }

  if (props.showAllFilterOptions) {
    return searchPageStore.filteredSectionResults(props.filterDefinition);
  }

  return props.filterDefinition.options;
});

const handleSelectChange = (event, filterSingle?: any) => {
  if (!event.target) return;
  const selectedValue = event.target.value;
  const selectedItem =
    filterSingle.options.find((item) => item.id == selectedValue) || null;
  searchPageStore.selectFilter(event, selectedItem, filterSingle);
};

function selectFilter(
  event: Event,
  input: FilterOption,
  parent?: FilterDefinition
) {
  searchPageStore.selectFilter(event, input, parent);
}

return (_ctx: any,_cache: any) => {
  return (__props.filterDefinition.filterTypeName === 'radio')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.filterOption.name) + " ", 1),
          _createElementVNode("input", {
            type: "radio",
            name: 'radio' + __props.filterDefinition.queryParameter,
            checked: __props.filterOption.checked,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (selectFilter($event, __props.filterOption, __props.filterDefinition)))
          }, null, 40, _hoisted_3),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, null, -1))
        ])
      ]))
    : (__props.filterDefinition.filterTypeName === 'checkbox')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _createTextVNode(_toDisplayString(__props.filterOption.label || __props.filterOption.name) + " ", 1),
            _createElementVNode("input", {
              type: "checkbox",
              name: 'checkbox' + __props.filterDefinition.queryParameter,
              checked: __props.filterOption.checked,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (selectFilter($event, __props.filterOption)))
            }, null, 40, _hoisted_6),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, null, -1))
          ])
        ]))
      : (__props.filterDefinition.filterTypeName === 'select')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("select", {
              onChange: _cache[2] || (_cache[2] = ($event: any) => (handleSelectChange($event)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (item, itemIndex) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: itemIndex,
                  value: item.id,
                  selected: item.checked
                }, _toDisplayString(item.label || item.name), 9, _hoisted_8))
              }), 128))
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9))
}
}

})